<template>
  <PaymentHistory />
</template>

<script>
import PaymentHistory from '@/components/Hub/PaymentHistory/PaymentHistory.vue'

export default {
  name: 'HubPaymentHistoryPage',

  components: { PaymentHistory }
}
</script>
